const divideHexToRGBA = (hex: string, opacity = 100, brightness = 1) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!result) return { r: 0, g: 0, b: 0 }

  return {
    r: Math.round(parseInt(result[1], 16) * brightness),
    g: Math.round(parseInt(result[2], 16) * brightness),
    b: Math.round(parseInt(result[3], 16) * brightness),
    a: opacity / 100,
  }
}

export const getContrast = (color: string): string | undefined => {
  if (color?.length) {
    const hc = color.replace('#', '')
    const [r, g, b] = [0, 2, 4].map((p) => parseInt(hc.substring(p, p + 2), 16))
    const yiq = (r * 299 + g * 587 + b * 114) / 1000 >= 250

    return yiq ? '#141414' : '#F7F5F2'
  }
}

export const hexToRgb = (hexCode: string, opacity?: number): string | undefined => {
  if (!hexCode) {
    return
  }

  const { r, g, b } = divideHexToRGBA(hexCode)

  if (opacity) {
    return `rgba(${r},${g},${b},${opacity / 100})`
  }

  return `rgb(${r},${g},${b})`
}

export const isColorTooBright = (hexColor: string): boolean => {
  const rgb = divideHexToRGBA(hexColor)
  const brightness = rgb.r * 0.2126 + rgb.g * 0.7152 + rgb.b * 0.0722

  return brightness > 200
}
